export default __webpack_public_path__ + "static/media/blog-detail.4250e12b.png";